import React from 'react';
import { z } from 'zod';
import { Box, Button, TextField } from '@mui/material';
import { useUserState } from '../contexts/UserContext';

const LowerCaseAlpha = z
  .string()
  .refine((value) => /^[a-z]+$/.test(value), 'Name contains lowercase alphabet');

const Email = z.string().email();

function validate(e: string) {
  const lowerCaseAlpha = LowerCaseAlpha.safeParse(e);
  const email = Email.safeParse(e);
  return lowerCaseAlpha.success || email.success;
}

export const NonDappLogin = () => {
  const { isSelfSignedToken, login } = useUserState();
  const [inputValidated, setInputValidated] = React.useState(false);
  const [userId, setUserId] = React.useState<string>('');
  const loginKey = async (key: string) => {
    if (key === 'Enter') {
      await login(userId);
    }
  };
  const [showUserIdAsTitle] = React.useState(false);

  // If you want to display the user id in the title, e.g., for demo purposes, simply set the
  // showUserIdAsTitle state to true above.
  React.useEffect(() => {
    if (userId && showUserIdAsTitle) {
      document.title = userId.toUpperCase();
    }
  }, [userId, showUserIdAsTitle]);
  return (
    <Box sx={{ mt: 1 }}>
      {isSelfSignedToken() ? (
        <>
          <TextField
            margin="normal"
            required
            fullWidth
            id="login-userid-input"
            placeholder="User Id"
            name="userid"
            autoComplete="username"
            autoFocus
            onChange={(event) => {
              setInputValidated(validate(event.target.value));
              setUserId(event.target.value);
            }}
            onKeyDown={(event) => {
              // eslint-disable-next-line @typescript-eslint/no-floating-promises
              loginKey(event.key);
            }}
          />

          <Button
            type="submit"
            fullWidth
            disabled={!inputValidated}
            sx={{ mt: 3, mb: 2 }}
            id="login-button"
            onClick={() => {
              // eslint-disable-next-line @typescript-eslint/no-floating-promises
              login(userId);
            }}
          >
            Log In
          </Button>
        </>
      ) : (
        <Button
          type="submit"
          fullWidth
          sx={{ mt: 3, mb: 2 }}
          id="login-button"
          autoFocus
          onClick={() => {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            login('');
          }}
        >
          Log In
        </Button>
      )}
    </Box>
  );
};
